import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { contentCountsRequest } from '~src/spacesPlatform/actions/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '~src/spacesPlatform/selectors/ContentCountsSelector';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { canPerformAnyAction } from '../../../../resourceActions/selectors/ResourceActionsSelectors';
import { getSessionManagementServiceInstance } from '../../../../sessionManagement/SessionManagementService';
import { addSiteUsersToGroup } from '../../actions/GroupMenuActions';
import { GroupSpace, GroupSpaceDispatchProps, GroupSpaceStateProps } from './GroupSpace';

const mapStateToProps: MapStateToProps<GroupSpaceStateProps> = (state: AppState) => ({
    spaceInfo: selectSpaceInfo(state),
    contentCounts: selectContentCounts<'group'>(state, 'group'),
    contentCountsUpToDate: selectContentCountsUpToDate(state),
    canSessionUserManageUsers: SessionUserSelectors.canManageUsers(state),
    canSeeGroupMembers: getSessionManagementServiceInstance().isAdminProfilesEnabled()
      ? canPerformAnyAction(state, 'User', ['SEE_SITE_USERS'])
      : true,

});

const mapDispatchToProps: MapDispatchToProps<GroupSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest,
    addSiteUsersToGroup: addSiteUsersToGroup
  },
  dispatch);

export const ConnectedGroupSpace = connect(mapStateToProps, mapDispatchToProps)(GroupSpace);
